





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AtTa from 'vue-at/dist/vue-at-textarea'
import { IAtMember } from '@/entities/chat'
import {pendoTrackEvent} from '@/utils/pendo'

/*
    This is supposed to sit fixed at the bottom of the screen,
    you'd place it in a WebViewScreen footer slot

    Emits:

    'submit' string
    'input' string
*/

@Component<TextInput>({
    components: {
        AtTa
    },
    model: {
        prop: 'value',
        event: 'input'
    }
})
export default class TextInput extends Vue {
    @Prop({ type: String, default: '' }) public placeholder!: string
    @Prop({ type: String, default: 'Send' }) public submitLabel!: string
    @Prop({ type: Array, default: [] }) public members!: IAtMember[]

    public value = ''
    public mentions: IAtMember[] = []

    //TODO: Clean this up entire file up, seems to be taken from MentionableEditor.
    public memberSort(name, chunk) {
        return name.toLowerCase().indexOf(chunk.toLowerCase()) === 0
    }

    public onInputKeydown(evt) {
        if (evt.key === '@') {
            pendoTrackEvent('mention_started')
        }
    }

    public onInsertMention(recipient: IAtMember) {
        const mentions = this.members.filter((mention) =>
            this.value.includes(`@${mention.name} `)
        )
        this.mentions = mentions
        pendoTrackEvent('mention_added')
        this.$emit('mention', mentions)
    }

    public setValue(event: Event) {
        const value = String((event.target as HTMLTextAreaElement).value)
        this.value = value
        this.$emit('input', value)

        // re-generate since some members could be removed
        this.mentions = this.members.filter((mention) =>
            this.value.includes(`@${mention.name} `)
        )
        this.$emit('mention', this.mentions)
    }

    public handleSubmit(event: Event) {
        event.preventDefault()
        this.$emit('submit', String(this.value), this.mentions)
        this.value = ''
    }
}
